import { ButtonRoundedSm } from '@apps-common/components/elements'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

export const UnitAddOptionsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: any
}) => (
  <ModalContainer innerClasses='!min-h-0 !h-auto sm:!max-w-[300px]'>
    <ModalHeaderContainer>
      <div className='flex items-center justify-between'>
        <ModalHeader subtitle='Selection' title='Create Device' />
        <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
      </div>
    </ModalHeaderContainer>
    <ModalBody classes='!pt-[100px] !pb-[20px]'>
      <div className='flex flex-col gap-[20px]'>
        <ButtonRoundedSm
          type='button'
          loading={false}
          text='Add single'
          icon={<commonIcons.add className='text-[1.1rem]' />}
          iconRight
          className='bg-brand text-on-brand'
          callback={() => onDismiss('create-single', ModalDismiss.Confirm)}
        />
        <ButtonRoundedSm
          type='button'
          loading={false}
          text='Add multiple'
          icon={<commonIcons.addMultiple className='text-[1.1rem]' />}
          iconRight
          className='action-brand'
          callback={() => onDismiss('create-multiple', ModalDismiss.Confirm)}
        />
      </div>
    </ModalBody>
  </ModalContainer>
)
